var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Investor Selection")]),
    _vm._v(" "),
    !_vm.is_premium && _vm.is_load
      ? _c("img", {
          staticStyle: {
            width: "100%",
            "max-width": "1280px",
            display: "block",
          },
          attrs: { src: "/images/investors_preview.png?t=1" },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.is_premium && !_vm.investors.length
      ? _c("p", [_vm._v("Please wait, Investors are loading ...")])
      : _vm._e(),
    _vm._v(" "),
    _vm.is_premium && _vm.investors.length && _vm.is_premium_investors
      ? _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
          _vm._v(
            "Please find below the list of suitable and pre-qualified investors for your offering. "
          ),
          _c("br"),
          _vm._v(
            "\n    You can uncheck any of the investors below if you already have an existing relationship with them or if you don't want to approach them. "
          ),
          _c("br"),
          _vm._v(
            "Once you are happy with the list, please make sure to click on the button “CONFIRM SELECTION” below."
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.is_premium && _vm.investors.length && !_vm.is_premium_investors
      ? _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
          _vm._v(
            "The final investor list is being compiled for you right now. After that you will have the opportunity to deactivate any existing relationships and confirm the selection."
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.is_premium &&
    _vm.is_premium_investors &&
    _vm.questionnaire_step < 4 &&
    _vm.is_load
      ? _c("div", [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    _vm.is_premium &&
    _vm.is_premium_investors &&
    _vm.investors.length &&
    _vm.questionnaire_step > 3
      ? _c("div", { staticClass: "pta-investor-selection" }, [
          _c(
            "table",
            { attrs: { cellpadding: "0", cellspacing: "0" } },
            [
              _vm._m(1),
              _vm._v(" "),
              !_vm.investors
                ? _c("tr", [
                    _c("td", { attrs: { colspan: "6", align: "center" } }, [
                      _vm._v("\n          Data is loading ...\n        "),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.investors, function (investor) {
                return _vm.investors && investor.name
                  ? _c("tr", [
                      _c("td", { attrs: { valign: "top" } }, [
                        _c("input", {
                          attrs: {
                            disabled: _vm.is_confirmed,
                            type: "checkbox",
                          },
                          domProps: {
                            value: investor.id,
                            checked:
                              investor.pivot.is_deactive == 2 ? false : true,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.updateInvestorStatus(investor)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", {
                        attrs: { valign: "top" },
                        domProps: { innerHTML: _vm._s(investor.name) },
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { valign: "top" } },
                        _vm._l(
                          investor.investor_types,
                          function (investor_type) {
                            return _c("span", [_vm._v(_vm._s(investor_type))])
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { valign: "top" } },
                        _vm._l(investor.asset_classes, function (asset_class) {
                          return _c("span", [_vm._v(_vm._s(asset_class))])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { valign: "top" } },
                        _vm._l(investor.geos, function (geo) {
                          return _c("span", [_vm._v(_vm._s(geo))])
                        }),
                        0
                      ),
                    ])
                  : _vm._e()
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.is_premium && _vm.investors.length && _vm.is_premium_investors
      ? _c(
          "a",
          {
            staticClass: "pta-button",
            class: _vm.is_confirmed ? "pta-button-inactive" : "",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.confirmSelection.apply(null, arguments)
              },
            },
          },
          [_vm._v("CONFIRM SELECTION")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("i", [
      _vm._v("Please complete the "),
      _c("a", { attrs: { href: "/account/questionnaire" } }, [
        _vm._v("questionnaire"),
      ]),
      _vm._v(" first."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th"),
      _vm._v(" "),
      _c("th", [_vm._v("Organisation")]),
      _vm._v(" "),
      _c("th", [_vm._v("Investor Type")]),
      _vm._v(" "),
      _c("th", [_vm._v("Preferred Asset Class")]),
      _vm._v(" "),
      _c("th", [_vm._v("Preferred Geographic Area")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }